export default {
  WEEK: 'week',
  MONTH: 'month',
  ALL: 'all',
};
